"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Toggle = _interopRequireDefault(require("./Toggle"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "toggle": "DefaultTheme__toggle___2zuEa",
  "toggle-shape": "DefaultTheme__toggle-shape___32hof",
  "toggle-value": "DefaultTheme__toggle-value___1XTAT",
  "checked": "DefaultTheme__checked___2MWPP",
  "disabled": "DefaultTheme__disabled___u7BKa",
  "has-error": "DefaultTheme__has-error___Flkgx",
  "toggleShape": "DefaultTheme__toggle-shape___32hof",
  "toggleValue": "DefaultTheme__toggle-value___1XTAT",
  "hasError": "DefaultTheme__has-error___Flkgx"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "toggle": "DarkTheme__toggle___32LRg",
  "switch": "DarkTheme__switch___3dJxv",
  "toggle-value": "DarkTheme__toggle-value___3WK4M",
  "toggleValue": "DarkTheme__toggle-value___3WK4M"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "toggle": "LumeTheme__toggle___2Em9L"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Toggle["default"].displayName, themes.DefaultTheme)(_Toggle["default"]);
ThemedComponent.displayName = _Toggle["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map